import React, { useState, useEffect } from 'react';
import './App.css';
import { trimText } from './textTrimmer';

function App() {
  const [inputText, setInputText] = useState('');
  const [outputText, setOutputText] = useState('');
  const [isDarkMode, setIsDarkMode] = useState(false);
  const [isOptimizing, setIsOptimizing] = useState(false);
  const [copyStatus, setCopyStatus] = useState('');

  useEffect(() => {
    // Check system preference on mount
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    setIsDarkMode(prefersDark);
  }, []);

  const handleTextChange = (e) => {
    const text = e.target.value;
    setInputText(text);
  };

  const handlePaste = (e) => {
    e.preventDefault();
    // Get plain text from clipboard
    const pastedText = e.clipboardData.getData('text/plain');
    // Get selection range
    const start = e.target.selectionStart;
    const end = e.target.selectionEnd;
    // Replace selected text (or insert at cursor if no selection)
    const newText = inputText.slice(0, start) + pastedText + inputText.slice(end);
    setInputText(newText);
  };

  const handleOptimize = () => {
    setIsOptimizing(true);
    // Use setTimeout to ensure UI updates before processing
    setTimeout(() => {
      setOutputText(trimText(inputText));
      setIsOptimizing(false);
    }, 0);
  };

  return (
    <div className={`App ${isDarkMode ? 'dark' : 'light'}`}>
      <main>
        <div className="header">
          <h1>Chinese Text Optimizer</h1>
          <button 
            className="theme-toggle"
            onClick={() => setIsDarkMode(!isDarkMode)}
            aria-label={isDarkMode ? "Switch to light mode" : "Switch to dark mode"}
          >
            {isDarkMode ? '☀️' : '🌙'}
          </button>
        </div>
        <div className="input-container">
          <h2>Input Text</h2>
          <textarea
            value={inputText}
            onChange={handleTextChange}
            onPaste={handlePaste}
            placeholder="Enter Chinese text here (max 300 characters)..."
          />
          <div className="char-count">
            Characters: <span className={inputText.length > 300 ? 'over-limit' : ''}>{inputText.length}</span>/300
          </div>
          <button 
            className="optimize-button"
            onClick={handleOptimize}
            disabled={isOptimizing}
          >
            {isOptimizing ? 'Optimizing...' : 'Optimize Text'}
          </button>
        </div>
        <div className="output-container">
          <h2>Optimized Text</h2>
          <textarea
            value={outputText}
            readOnly
          />
          <div className="output-actions">
            <div className="char-count">
              Characters: <span className={outputText.length > 300 ? 'over-limit' : ''}>{outputText.length}</span>/300
            </div>
            <button 
              className="copy-button"
              onClick={() => {
                navigator.clipboard.writeText(outputText)
                  .then(() => {
                    setCopyStatus('Copied!');
                    setTimeout(() => setCopyStatus(''), 2000);
                  })
                  .catch(() => {
                    setCopyStatus('Failed to copy');
                    setTimeout(() => setCopyStatus(''), 2000);
                  });
              }}
              disabled={!outputText}
            >
              {copyStatus || 'Copy'}
            </button>
          </div>
        </div>
      </main>
    </div>
  );
}

export default App;
